module.exports = __webpack_public_path__ + "img/Elements_Icons_Data Dashboards.826c9b58.png";